/**
 * Formats a date string to a delivery date string.
 * 
 * @param {string} dateString The date string to format.
 * @param {object} [options] Optional parameters.
 * @param {string} [options.prefix='Delivery'] The prefix to add to the formatted date string.
 * @param {boolean} [options.includeDayName=true] Whether to include the day name in the formatted date string.
 * @param {string} [options.dateFormat='MM-DD-YYYY'] The format of the date string.
 * @param {string} [options.locale='en-US'] The locale to use for formatting the date string.
 * @return {string} The formatted date string.
 */


function formatDateToDelivery(dateString, options = {}) {
  const {
    prefix = 'Delivery',
    includeDayName = true,
    dateFormat = 'MM-DD-YYYY',
    locale = 'en-US'
  } = options;
  
  const date = new Date(dateString);
  
  // Вариант с использованием Intl.DateTimeFormat (более современный)
  const dayName = new Intl.DateTimeFormat(locale, { 
    weekday: 'long',
    timeZone: 'UTC'
  })?.format(date);
  
  // Форматируем дату
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date?.getUTCFullYear();
  
  // Формируем строку даты в нужном формате
  let formattedDate;
  switch (dateFormat) {
    case 'MM-DD-YYYY':
      formattedDate = `${month}-${day}-${year}`;
      break;
    case 'DD-MM-YYYY':
      formattedDate = `${day}-${month}-${year}`;
      break;
    case 'YYYY-MM-DD':
      formattedDate = `${year}-${month}-${day}`;
      break;
    default:
      formattedDate = `${month}-${day}-${year}`;
  }
  
  // Собираем итоговую строку
  if (includeDayName) {
    return `${prefix} ${dayName}, ${formattedDate}`;
  } else {
    return `${prefix} ${formattedDate}`;
  }
}

export default formatDateToDelivery